import { el, mount } from 'redom';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

class ExternalFontFamiliesManager {

  constructor(application) {

    this.application = application;
    this.styleBlockId = 'application-font-families';

    this.fontFamilies = [];
    this.applicationFontFamilies = null;

  }

  createFontFamiliesStyleBlock() {

    this.applicationFontFamilies = document.getElementById(this.styleBlockId);

    if (this.applicationFontFamilies !== null) {
      return;
    }

    this.applicationFontFamilies = el('style#' + this.styleBlockId);

    mount(document.head, this.applicationFontFamilies);

  }

  initialize() {
    this.createFontFamiliesStyleBlock();
  }

  generateFontFaceStyle(fontFamilyName, face) {

    const fileURL = `${import.meta.env.REACT_APP_ASSETS_URL}/assets/fonts/external/${fontFamilyName}/${face.file}`;

    return `
      @font-face {
        font-family: '${fontFamilyName}';
        font-style: ${face.style};
        font-weight: ${face.weight};
        src: url('${fileURL}') format('${face.format}');
      }
    `;

  }

  generateFontFamilyStyle(fontFamily) {

    const font = this.application.system.findExternalFontFamily(fontFamily.name);

    return font.faces.map(function toStyle(face) {
      return this.generateFontFaceStyle(fontFamily.name, face);
    }, this).join('\n');

  }

  generateFontFamiliesStyles() {

    const styles = [];

    const fontFamilies = this.fontFamilies;

    for (let fontFamily of fontFamilies) {
      const style = this.generateFontFamilyStyle(fontFamily);
      styles.push(style);
    }

    return styles.join('\n');

  }

  applyFontFamilies() {

    if (!this.applicationFontFamilies) {
      return;
    }

    const styles = this.generateFontFamiliesStyles();

    this.applicationFontFamilies.innerHTML = styles;

  }

  deactivateFontFamilies(fontFamilyReferences) {

    const fontFamilies = this.fontFamilies;

    for (let fontFamily of fontFamilies) {

      const fontFamilyName = fontFamily.name;

      if (fontFamilyReferences[fontFamilyName] === void 0) {
        continue;
      }

      if (this.application.system.isExternalFontFamily(fontFamilyName) === false) {
        continue;
      }

      fontFamily.count -= fontFamilyReferences[fontFamily.name];

    }

    const _fontFamilies = [];

    for (let fontFamily of fontFamilies) {

      if (fontFamily.count === 0) {
        continue;
      }

      _fontFamilies.push(fontFamily);

    }

    this.fontFamilies = _fontFamilies;

    this.applyFontFamilies();

  }

  creatFontFamiliesFromReferrences(fontFamilyReferences) {

    const fontFamilies = [];

    for (let fontFamilyName in fontFamilyReferences) {

      if (this.application.system.isExternalFontFamily(fontFamilyName) === false) {
        continue;
      }

      const fontFamily = {
        name: fontFamilyName,
        count: fontFamilyReferences[fontFamilyName]
      };

      fontFamilies.push(fontFamily);

    }

    return fontFamilies;

  }

  mergeWithFontFamilies(fontFamilies) {

    const newFontFamilies = [];
    const _fontFamilies = this.fontFamilies;

    for (let fontFamily of fontFamilies) {

      const index = findIndexByPropertyValue(_fontFamilies, 'name', fontFamily.name);

      if (index === -1) {
        newFontFamilies.push(fontFamily);
      } else {
        _fontFamilies[index].count = _fontFamilies[index].count + fontFamily.count;
      }

    }

    this.fontFamilies = [..._fontFamilies, ...newFontFamilies];

  }

  activateFontFamilies(fontFamilyReferences) {

    const fontFamilies = this.creatFontFamiliesFromReferrences(fontFamilyReferences);

    this.mergeWithFontFamilies(fontFamilies);

    this.applyFontFamilies();

    return function deactivateFontFamilies() {

      this.deactivateFontFamilies(fontFamilyReferences);

    }.bind(this);

  }

}

ExternalFontFamiliesManager.fontFamilyArrayToReferences = function fontFamilyArrayToReferences(fontFamilies) {

  const references = {};

  for (let fontFamily of fontFamilies) {

    references[fontFamily.name] = 1;

  }

  return references;

};

export default ExternalFontFamiliesManager;